<template>
  <div
    class="flex flex-wrap align-center"
    data-qa="offers-actions-snackbar">
    <StartAnalizAI
      v-if="showActions.showAnalizAI"
      class="mr-2"
      :item="elements"
      :tender-id="options.tender?.tenderId"/>
    <template v-if="showActions.confirmReject">
      <sBadge
        color="var(--white-color)"
        :content="elements.length"
        data-qa="offers-acctions-toolbar-badge"
        offset-x="10"
        offset-y="20"
        overlap
        text-color="var(--black-color)">
        <sButton
          class="px-4"
          color="var(--white-color)"
          data-qa="btn-confirm"
          :disabled="!canAgree(true)"
          :loading="loading === 'ACTIVE'"
          small
          type="border"
          @click="agree(true, '')">
          {{ $t('Application.Confirm') }}
        </sButton>
      </sBadge>
      <RejectDialog
        class-name="mx-2"
        :disabled="!canAgree(false)"
        :elements.sync="elements"
        :loading="loading === 'CANCELED'"
        mode="toolbar"
        offer
        @callback="callbackRject"/>
    </template>
    <sBadge
      v-if="showActions.formContract"
      class="mx-0"
      color="var(--white-color)"
      :content="elements ? elements.length : null"
      data-qa="offers-acctions-toolbar-badge"
      offset-x="24"
      offset-y="15"
      overlap
      text-color="var(--black-color)">
      <sButton
        class="mr-3 px-4"
        color="var(--white-color)"
        data-qa="btn-form-contract-new"
        small
        type="border"
        @click="createContract">
        {{ $t('Tenders.FormContract') }}
      </sButton>
    </sBadge>
    <sBadge
      v-if="itemComAdditional && itemComAdditional.length"
      class="mx-0"
      color="var(--white-color)"
      :content="itemComAdditional.length"
      data-qa="offers-acctions-toolbar-badge"
      offset-x="24"
      offset-y="15"
      overlap
      text-color="var(--black-color)">
      <sButton
        class="mr-3 px-4"
        color="var(--white-color)"
        data-qa="btn-form-contract-new"
        small
        type="border"
        @click="createAddAgreementAsync">
        {{ $t('Tenders.AdditionalAgreement') }}
      </sButton>
    </sBadge>
    <ChooseWinnerBtn
      v-if="showActions.chooseWinner"
      :options="options"/>
    <AskQuestion
      v-if="showActions.askQuestion"
      :bids="elements"
      :tender="options.tender"
      @hideActions="options.callback"/>
    <CompareTableBtn
      v-if="showActions.compareTable"
      :elements="elements"
      :route="compareRoute"
      :tender-id="options.tender.tenderId"/>
    <AnnulBidDialog
      v-if="showActions.annulBid"
      :bids="elements"
      :external="showActions.external"
      :tender="options.tender"
      @callback="options.callback"/>
    <ForeignOffer
      v-if="showActions.external"
      :foreign_offer="first"
      :tender="options.tender"
      @hideActions="options.callback"/>
    <template v-if="showActions.bigMode">
      <RatingDialog
        v-if="showMenuItemRating"
        data-qa="menu-item-supplier-rating"
        :organization-id="elements[0].bidderInfo.organizationId"
        :organization-title="elements[0].bidderInfo.organizationName"
        @changeRatings="options.callback"/>
      <sButton
        v-for="item in visibleMenuItems"
        :key="item.key"
        color="var(--white-color)"
        :data-qa="item.dataQa"
        :disabled="item.disabled"
        :icon="item.icon"
        :to="item.to"
        type="text"
        @click="item.click && item.click()">
        {{ item.label }}
      </sButton>
      <OfferDifferentPrice
        v-if="showMenuItemOfferPrice"
        data-qa="menu-item-offer-different-price"
        :elements="elements"
        :tender="options.tender"
        @callback="options.callback"/>
    </template>
    <sPopover
      v-else
      ref="subMenuPopover"
      v-model="visibleSubMenu"
      :open-delay="300"
      placement="bottom-end"
      trigger="click">
      <template #reference="{show}">
        <sButton
          v-show="showActions.menu"
          slot="reference"
          color="var(--white-color)"
          :data-qa="`btn-menu-${show ? 'active' : ''}`"
          icon="menu"
          icon-size="20px"
          small
          type="text"/>
      </template>
      <div>
        <RatingDialog
          v-if="showMenuItemRating"
          data-qa="menu-item-supplier-rating"
          list
          :organization-id="elements[0].bidderInfo.organizationId"
          :organization-title="elements[0].bidderInfo.organizationName"
          @changeRatings="options.callback"/>
        <MenuItem
          v-for="item in visibleMenuItems"
          :key="item.key"
          :data-qa="item.dataQa"
          :disabled="item.disabled"
          :icon="item.icon"
          :label="item.label"
          :to="item.to"
          @click="item.click && item.click()"/>
        <OfferDifferentPrice
          v-if="showMenuItemOfferPrice"
          data-qa="menu-item-offer-different-price"
          :elements="elements"
          list
          :tender="options.tender"
          @callback="options.callback"/>
      </div>
    </sPopover>
    <SupplierInspectionDecisionModal
      v-if="showMenuSupplierInspectionDecision"
      :show.sync="showDecisionForm"
      :supplier="elements[0]"
      :tender-id="options.tender.tenderId"
      :use-data="false"/>
  </div>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import AskQuestion from 'components/tenders/dialogs/AskQuestion.vue'
import RatingDialog from 'components/common/dialogs/RatingDialog.vue'
import AnnulBidDialog from 'components/tenders/dialogs/AnnulBidDialog.vue'
import ForeignOffer from 'pages/tender item/foreign offer/ForeignOffer.vue'
import StartAnalizAI from 'components/common/elements/BtnStartAnalizAI.vue'
import RejectDialog from 'components/purchasing/purch item/RejectDialog.vue'
import ChooseWinnerBtn from 'components/tenders/tender page/ChooseWinnerBtn.vue'
import CompareTableBtn from 'components/tenders/actions toolbar/CompareTableBtn.vue'
import SupplierInspectionDecisionModal from 'components/supplies/SupplierInspectionDecisionModal.vue'
import OfferDifferentPrice from 'components/tenders/tender page/offer different price/OfferDifferentPrice.vue'

import SmarttenderApi from '@/api/smarttenderApi'
import moment from 'moment'
import { tenderMixin } from 'mixins'
import contractingMixin from 'mixins/contractingMixin'

const tender_api = new SmarttenderApi()

export default {
  name: 'offersActionsToolbar',
  mixins: [tenderMixin, contractingMixin],
  data() {
    return {
      loading: false,
      showDecisionForm: false,
      visibleSubMenu: false
    }
  },
  props: {
    options: Object,
    reject_condition: Boolean
  },
  mounted() {
    this.$emit('update:reject_condition', this.options.name === 'members' && this.elements?.length > 1)
  },
  computed: {
    can_edit() {
      return this.$_checkCanEdit(this.options.tender, this.$_agreements)
    },
    /**
     * Строчні кнопки рендеряться підряд.
     * Якщо є хоч одна кнопка вкладеного меню — існує меню (гамбургер).
     * Якщо строчних кнопок немає зовсім, а меню є — меню розгортається у строчний вигляд (bigMode).
     */
    showActions() {
      const external = this.hasElements && this.options.tender.tenderStatus?.id === this.statuseKeys.BID_ANALYSIS && this.$can('have', 'ForeignSupplierBid') && this.elements.every(bid => bid.foreignBidderBid && bid.bidderInfo.email === this.first.bidderInfo.email)
      const isNotLotsHistory = this.options.name !== 'lot-offers-history'

      const result = {
        showAnalizAI: this.showAnalizAI,
        confirmReject: this.elements?.length && isNotLotsHistory && this.show_agreement,
        formContract: isNotLotsHistory && this.show_contract_forming,
        chooseWinner: this.hasElements && isNotLotsHistory && this.options.name !== 'members' && this.can_edit,
        askQuestion: this.showAskQuestion,
        compareTable: this.hasElements && this.options.name !== 'members',
        external: external,
        annulBid: external
        || (
          this.hasElements
          && this.options.name !== 'members' && isNotLotsHistory && this.$can('delete', 'Bid')
          && (this.options.tender.tenderStatus.id === this.statuseKeys.SUBMISSION || this.options.tender.tenderStatus.id === this.statuseKeys.AUCTION)
        ),
        menu: (this.options.name === 'lot-offers' || this.options.name === 'members') && (
          this.showMenuAddToStopList
          || this.showMenuItemOfferPrice
          || this.showMenuItemRating
          || this.showMenuSupplierInspectionDecision),
      }

      const hasInline = Object.entries(result).some(([key, value]) => key !== 'menu' && value)

      result.toolbar = hasInline || result.menu
      result.bigMode = !hasInline && result.menu

      this.$emit('showActions', result)
      return result
    },
    hasElements() {
      return !!this.elements?.length
    },
    elements() {
      const result = this.options.elements
        .filter(i => i.bidderInfo?.contactId)
        || []
      this.$emit('update:reject_condition', this.options.name === 'members' && result?.length > 1)
      return result
    },
    first() {
      return this.elements[0] || {}
    },
    compareRoute() {
      return {
        name: this.options.compare_name || 'comparativeTable',
        params: {
          tenderId: this.options.tender?.tenderId,
          lotId: this.options.item?.lotId,
          participantId: this.options.participant,
          org: this.$route.params.org
        }
      }
    },
    showAnalizAI() {
      if (this.options.tender.tenderStatus.id !== this.statuseKeys.BID_ANALYSIS) {
        return false
      }

      if (!this.growthBook.ai_functionals) {
        return false
      }
      if (!this.elements?.length || !this.$can('use', 'aiRequirementsFromDocument')) {
        return false
      }
      if (this.elements.some(el => el.requirements?.status !== 'NOT_STARTED')) {
        return false
      }
      return this.elements.some(el => !el.requirements || el.requirements?.status === 'NOT_STARTED')
    },
    showAskQuestion() {
      return (this.can_edit || this.options.tender?.tenderAccess?.includes('ALLOW_SEND_SUPPLIER_QUESTION'))
          && this.elements?.length && this.options.name !== 'lot-offers-history' && this.options.name !== 'members' && this.$can('set', 'privateMessageToBidder')
          && !this.options.tender.hasRoute && !this.elements.some(bid => bid.foreignBidderBid)
    },
    showMenuAddToStopList() {
      if (this.elements?.length !== 1) {
        return false
      }
      return true
    },
    showMenuSupplierInspectionDecision() {
      if (!this.elements?.length || this.$acl.get.includes('tenders_view')) {
        return false
      }
      const orgIds = new Set(this.elements.map(element => element.bidderInfo.organizationId))
      return orgIds.size === 1 // Ключ организации участника должен біть уникальным
    },
    showMenuItemRating() {
      if (!this.elements?.length || this.options.name !== 'lot-offers') {
        return false
      }
      const accessStatus = [this.statuseKeys.COMPLETED, this.statuseKeys.PURCHASE_NOT_PLACED]
      return this.options?.name === 'lot-offers' && accessStatus.includes(this.options?.tender?.tenderStatus?.id) && this.elements?.length === 1
    },
    showMenuItemOfferPrice() {
      if (!this.elements?.length || this.options.name !== 'lot-offers') {
        return false
      }

      if (this.options?.criteryCard?.criterias?.some(c => c.criterionKind === 'VARIANT')) {
        return false
      }

      const status = this.options.tender?.tenderStatus?.id
      const hasDraft = this.elements.some(el => el.foreignBidderBid || el.bidStatus === 'DRAFT')
      return !hasDraft &&
        (
          (status === this.statuseKeys.BID_ANALYSIS && this.$can('send', 'priceConfirmation') && this.options.tender.biddingType.allowPriceRequest) ||
          (status === this.statuseKeys.SUBMISSION && this.$can('counteroffer', 'OnTendering') && this.options.tender.biddingType.allowCounterOffer) ||
          this.options.tender?.tenderAccess?.includes('ALLOW_SEND_PRICE_REQUEST')
        )
    },
    menuItems() {
      return [
        {
          key: 'supplierInspectionDecision',
          show: this.showMenuSupplierInspectionDecision,
          dataQa: 'add-chec-bidder',
          icon: 'plus-circle',
          label: this.$t('Tenders.addVerificationInformation'),
          click: () => { this.showDecisionForm = true; this.visibleSubMenu = false },
        },
        {
          key: 'addToStopList',
          show: this.showMenuAddToStopList,
          dataQa: 'menu-item-add-to-stop-list',
          icon: 'stopped-person',
          label: this.$t('StopLists.AddToStopList'),
          disabled: this.$acl.get.includes('tenders_view'),
          to: {
            name: 'addToStopList',
            params: { org: this.$route.params.org },
            query: {
              usreou: this.first?.usreou || this.first?.organizationUsreou || this.first?.bidderInfo?.usreou,
              id: this.first?.organizationId || this.first?.bidderInfo?.organizationId,
              from: this.options.tender.tenderId
            }
          },
        },
      ]
    },
    visibleMenuItems() {
      return this.menuItems.filter(item => item.show)
    },
    isKDUContract() {
      return this.$can('access', 'contracting')
    },
    show_contract_forming() {
      if (!this.options.tender?.bids?.length || !this.elements?.length) {
        return false
      }
      if (!this.isKDUContract && this.options.name !== 'lot-offers') {
        return false
      }
      if (this.elements.find(i => i.contractCount.contract?.all || i.bidDecisionAttribute === 'DEFAULT')) {
        return false
      }
      return (!this.isKDUContract || this.elements?.length === 1)
        && this.options.tender.tenderStatus.id === this.statuseKeys.COMPLETED
        && (this.first.selectedBid || this.first.winner)
        && (!this.first.contract || !this.first.contract?.length)
    },
    form_contract() {
      const usreou = this.getUsreou(this.first)
      return window.config.MySignyUrl + `scenario/tenderComContractOrg?id=${this.options.tender.tenderId}&code=${usreou}&lot=${this.elements.map(_ => _.lotId)}`
    },
    itemComAdditional() {
      if (!this.options.tender?.bids?.length
        || this.options.name !== 'lot-offers'
        || this.options.tender.tenderStatus.id !== this.statuseKeys.COMPLETED
        || !(this.first.selectedBid || this.first.winner)) {
        return []
      }
      const itemContract = this.$_.cloneDeep(this.elements).filter(i => i.bidDecisionAttribute !== 'DEFAULT' && i.contractCount?.all) || []

      if (!itemContract?.length || itemContract?.length !== this.elements?.length) {
        return []
      }

      const countContract = itemContract
        .filter((i) => i.contract?.length)
        .map(_ => `${_.contract[0].contractNumber}_${_.contract[0].documentDate}`)
        .filter((value, index, array) => array.indexOf(value) === index)
        .length

      if (countContract !== 1) {
        return []
      }
      return itemContract
    },
    formComAdditional() {
      const usreou = this.getUsreou(this.first)
      return window.config.MySignyUrl + `scenario/tenderComAdditional?code=${usreou}&id=${this.options.tender.tenderId}&lot=${this.itemComAdditional.map(_ => _.lotId)}`
    },
    show_agreement() {
      return this.options.retraining && this.can_edit
    }
  },
  methods: {
    getUsreou(element) {
      return element?.organizationUsreou || element?.usreou || element?.bidderInfo?.usreou || ''
    },
    canAgree(decision) {
      return this.elements.some(el => decision ? el.prequalification?.status !== 'ACTIVE' : el.prequalification?.status !== 'UNSUCCESSFULL' )
    },
    callbackRject(comm) {
      this.agree(false, comm)
    },
    async agree(decision, comm) {
      const status = decision ? 'ACTIVE' : 'UNSUCCESSFULL'
      this.loading = status

      const tenderId = this.options.tender.tenderId
      const model = this.elements.map(elem => ({
        idBidRow: elem.id,
        reason: comm,
        status: status,
      }))

      try {
        const res = await tender_api.changeDecisionOnPrequalification(tenderId, model)
        if (res) {
          this.elements.forEach(elem => {
            elem.prequalification = {
              decisionDate: moment().format('YYYY-MM-DDTHH:mm::ss'),
              reason: comm,
              status: status
            }
          })
        }
        this.options.callback()
      } catch (error) {
        this.$log_error(error.message)
      } finally {
        this.loading = false
      }
    },
    async createAddAgreementAsync() {
      if (!this.itemComAdditional?.length) {
        return
      }
      window.open(this.formComAdditional, '_blank')
    },
    async createContract() {
      if (this.isKDUContract) {
        const usreouList = this.elements.map(el => this.getUsreou(el).trim())
        await this.createContractAsync(this.options.tender?.tenderId, usreouList)
      } else {
        const usreouList = this.elements.map(el => this.getUsreou(el).trim())
        const uniqueUsreou = [...new Set(usreouList)]
        
        if (uniqueUsreou.length === 1) {
          window.open(this.form_contract, '_blank')
        } else {
          this.$notice.info({
            title: this.$t('Common.WarningTitle'),
            message: this.$t('Validate.SeveralOffersOnlyOneOrganization'),
            duration: 10
          })
        }
      }
    },
  },
  watch: {
    showActions() {
      if (this.visibleSubMenu && this.$refs.subMenuPopover) { // Дергаем сабменю, для пересчета позиций
        this.$refs.subMenuPopover.showPopper = !this.$refs.subMenuPopover.showPopper
        this.$nextTick(() => {
          this.$refs.subMenuPopover.showPopper = !this.$refs.subMenuPopover.showPopper
        })
      }
    }
  },
  components: {
    MenuItem,
    AskQuestion,
    RejectDialog,
    RatingDialog,
    ForeignOffer,
    StartAnalizAI,
    AnnulBidDialog,
    ChooseWinnerBtn,
    CompareTableBtn,
    OfferDifferentPrice,
    SupplierInspectionDecisionModal,
  }
}
</script>